import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getAllYears } from "../Store/Admin/believe/year/year";

export default function useFinancialYear() {
  const dispatch = useDispatch();
  const yearData = useSelector((state) => state?.getAllYears?.user?.data) || [];

  useEffect(() => {
    if (!yearData || yearData.length === 0) {
      dispatch(getAllYears());
    }
  }, [dispatch, yearData]);

  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonth = today.getMonth() + 1;

  // financial year starts in April
  const fyStart = currentMonth < 4 ? currentYear - 1 : currentYear;
  const fyEnd = fyStart + 1;

  const matchedYear = yearData?.find((y) => {
    const start = moment(y.start_year).year();
    const end = moment(y.end_year).year();
    return fyStart === start && fyEnd === end;
  });

  if (matchedYear) {
    return { id: matchedYear?._id, label: `${fyStart}-${fyEnd}` };
  }
 
  return { id: "", label: `${fyStart}-${fyEnd}` };
}
